<template>
  <div :class="$style.turntableContent" :style="{ backgroundImage: `url(${backgrounImgUrl}/bg11.jpg)` }">
    <div class="content">
      <van-image
        :src="`${backgrounImgUrl}/title.png`"
      />
    </div>
    <div :class="$style.turntable" :style="{ backgroundImage: `url(${backgrounImgUrl}/zhuanpan1.png)` }">
      
      <div :class="$style.pointerBox">
        <!-- width="308"
          height="300" -->
        <van-image
          
          :src="`${backgrounImgUrl}/pointer1.png`"
          :style="{transform: rotateAngle, transition: rotateTransition}"
        />
      </div>

      <!-- 抽奖按钮 -->
      <div :class="$style.lottery" @click="handleLottery">
        <!-- width="80"
          height="50" -->
        <van-image
          
          :src="`${backgrounImgUrl}/lottery1.png`"
        />
      </div>

       <!-- 手 -->
       <div :class="$style.hand" @click="handleLottery" :style="{transform: handrotateAngle}">
        <!-- width="80"
          height="80" -->
        <van-image
          
          :src="`${backgrounImgUrl}/hand1.png`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Image as VanImage, Toast } from 'vant'
import { getUserRewardInfo } from '@/apis/ksForm'
import { backgrounImgUrl } from './config'

export default {
  name: 'ksActivity',
  components: {
    // BigWheel
    VanImage
  },
  data () {
    return {
      backgrounImgUrl,
      turnsNumber: 5, // 转动的圈数
      turnsTime: 5, // 转动持续时间（秒）
      startRotateDegree: 0, // 开始转动的角度
      rotateAngle: 'rotate(50deg)', // 设置指针默认指向的位置,现在是默认指向1个扇形中间，设置为0即指向两个扇形之间的线上
      rotateTransition: '',
      loading: false,
      historyPhone: '',
      handrotateAngle: 'rotate(0deg)',
      isCheck: undefined,
      appkey: ''
    }
  },
  created () {
    localStorage.setItem('ksActivityQuery', JSON.stringify(this.$route.query))
    this.isCheck = localStorage.getItem('ksFormActivityCheck')
    this.appkey = this.$route.query.appkey
    this.historyPhone = localStorage.getItem('ksFormMobile') || ''
    this.onCheckRewardRecord()
  },
  methods: {
    // 检查是否有过领取记录
    onCheckRewardRecord () {
      const checkReward = this.historyPhone && this.appkey
      if (checkReward && !this.isCheck) {
        getUserRewardInfo({
          mobile: this.historyPhone,
          gameId: this.appkey
        }).then(res => {
          if (res.data) {
            // 有领过礼包码的时候，直接回到礼包码页面
            this.$router.push({
              path: '/ksForm/ksActivityGiftCode',
              query: {
                cdk: res.data.cdk
              }
            })
          } else {
            const lastAppkey = localStorage.getItem('ksActivityLastAppkey')
            if (lastAppkey === this.appkey) {
              // 有发送过验证码但是可能没支付
              this.$router.push({
                path: '/ksForm/ksActivityGift'
              })
            } else {
              // 这里逻辑改一下，如果没有领取记录，则清除本地记录
              // 因为可能是同一个手机号但是不同的游戏又进到了广告
              localStorage.setItem('ksActivityLastAppkey', this.appkey)
              this.historyPhone = ''
              localStorage.removeItem('ksFormMobile')
            }
          }
        }).catch(() => {})
      }
    },
    // 点击抽奖
    handleLottery () {
      if (this.loading) return;
      this.handrotateAngle = 'rotate(-5deg)'
      setTimeout(() => {
        this.handrotateAngle = 'rotate(0deg)'
      }, 100)
      this.loading = true
      const turnsTime = 5
      const rotateAngle = this.startRotateDegree + this.turnsNumber * 360 + 360 - (180 / 8 + 360 / 8 * -0.5) - this.startRotateDegree % 360
      this.startRotateDegree = rotateAngle
      this.rotateAngle = `rotate(${rotateAngle}deg)`
      this.rotateTransition = `transform ${turnsTime}s cubic-bezier(0.250, 0.460, 0.455, 0.995)`
      setTimeout(() => {
        this.loading = false
        Toast('恭喜你，抽到特等奖礼包')
        this.$router.push({
          path: '/ksForm/ksActivityGift'
        })
      }, 5000)
    },
  }
}
</script>

<style lang="scss" module>
.turntableContent {
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  // background-image: url('./bg1.jpg');
  background-size: 100% 100%;
  background-position: center; /* 让图片居中显示 */  
  background-repeat: no-repeat;
  // background-attachment: local; /* 背景随盒子滚动 */
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .content {
    width: 375px;
    height: 170px;
    background-color: skyblue;
  }
  .turntable {
    max-width: 375px;
    // height: 375px;
    height: 460px;
    background-size: 100% 100%;
    background-position: center; /* 让图片居中显示 */  
    background-repeat: no-repeat;
    position: relative;
    .pointerBox {
      width: 300px;
      height: 300px;
      position: absolute;
      top: 2px;
      left: 38px;
    }
    .lottery {
      width: 80px;
      height: 50px;
      position: absolute;
      left: 146px;
      top: 128px;
    }
    .hand {
      width: 80px;
      height: 80px;
      position: absolute;
      left: 200px;
      top: 150px;
    }
  }
}
</style>